// 9fbef606107a605d69c0edbcd8029e5d
import BONUS_POINTS_DAYS_CONSTANTS from '../BonusPointsDays.constants';
import { parseBoolean } from '../../../../../utils/badge.util';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';

export const getBonusData = (state) => state.BonusPointsDaysReducer?.get('bonusDaysData');
export const getIsFetching = (state) => state.BonusPointsDaysReducer?.get('isFetching');
export const getError = (state) => state.BonusPointsDaysReducer?.get('error');
export const getBonusDetailsContentId = () => {
  const placeRewardLabels = getDynamicLabelValues('global.placeRewards');
  let bonusDetailsCID;
  /* istanbul ignore else */

  if (placeRewardLabels.placeRewards && Array.isArray(placeRewardLabels.referred)) {
    placeRewardLabels.referred.forEach((label) => {
      /* istanbul ignore else */
      if (label.name === BONUS_POINTS_DAYS_CONSTANTS.BONUS_DETAILS_REF_LABEL)
        bonusDetailsCID = label.contentId;
    });
  }
  return bonusDetailsCID;
};

export const getBonusDetailsData = (state) => {
  return state.BonusPointsDaysReducer?.get('bonusPointsDetails');
};

export const getBonusPointsSwitch = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_BONUSDAY_ENABLED)
  );
};
